import { useMemo } from 'react';
import {
  createFoodCategoryGroup,
  useFoodTypesSelector,
} from 'src/hooks/useForm';

export default function FoodTypeSelector({ fullSize = false, ...other }) {
  const foodTypes = useFoodTypesSelector({ oldImages: true });

  const FoodCategoryGroup = useMemo(() => {
    console.log('execute');
    return createFoodCategoryGroup(foodTypes, { fullSize });
  }, [fullSize]);

  return <FoodCategoryGroup {...other} />;
}
